module.exports = __webpack_public_path__ + "media/images/duplicate-flag-b1bbca00ddb355f91ed6145c60853b11.svg";